import * as React from "react";
import { TrashIcon } from "lucide-react";
import { Button } from "../../components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger, } from "../../components/ui/alert-dialog";
export const ConfirmDeleteDialog = ({ onDelete, className, item, title, description, disabled, icon = React.createElement(TrashIcon, { className: "h-4 w-4" }), }) => {
    return (React.createElement(AlertDialog, null,
        React.createElement(AlertDialogTrigger, { asChild: true },
            React.createElement(Button, { variant: "ghost", size: "icon", disabled: disabled, className: className },
                icon,
                React.createElement("span", { className: "sr-only" }, "L\u00F6schen"))),
        React.createElement(AlertDialogContent, null,
            React.createElement(AlertDialogHeader, null,
                React.createElement(AlertDialogTitle, null, title),
                React.createElement(AlertDialogDescription, null, description)),
            React.createElement(AlertDialogFooter, null,
                React.createElement(AlertDialogCancel, null, "Abbruch"),
                React.createElement(AlertDialogAction, { onClick: () => onDelete(item) }, "Best\u00E4tigen")))));
};
//# sourceMappingURL=ConfirmDeleteDialog.js.map